var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.current.style.width)},[_vm._v(" "+_vm._s(_vm.current.value)+" "),(_vm.current.unit)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.current.unit)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }